import { useEffect, useRef, useState } from "react";
import { motion, useAnimation, useInView } from "framer-motion";
import { CgTwilio } from "react-icons/cg";
import IVRFlowChart from "../../Components/IVRFlowChart";
import { Link } from "react-router-dom";
import { FaArrowRight, FaTimes } from "react-icons/fa";
import { CTABanner } from "../../Components/PortfolioBlocks";
import BrandButton from "../../Components/BrandButton";

const ctaAccent = { base: "#0E7490", hover: "#155E75", dark: "#164E63", soft: "#ECFEFF", rgb: "22, 78, 99" };

export const TwilioIVRs = () => {


    const audioRef = useRef(null);
    const progressBarRef = useRef(null);

    const [progress, setProgress] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isEnded, setIsEnded] = useState(false);


    const fadeUp = {
        hidden: { opacity: 0, y: 30 },
        show: (i = 0) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: i * 0.15,
                duration: 0.6,
                ease: "easeOut",
            },
        }),
    };

    const fadeUp2 = {
        hidden: { opacity: 0, y: 30 },
        visible: (delay = 0) => ({
            opacity: 1,
            y: 0,
            transition: { duration: 0.8, ease: "easeOut", delay },
        }),
    };

    const headingRef = useRef(null);
    const paragraphRef = useRef(null);

    const headingControls = useAnimation();
    const paragraphControls = useAnimation();

    const isHeadingInView = useInView(headingRef, { once: true, amount: 0.4 });
    const isParagraphInView = useInView(paragraphRef, {
        once: true,
        amount: 0.4,
    });

    useEffect(() => {
        if (isHeadingInView) {
            headingControls.start("visible");
        }
    }, [isHeadingInView]);

    useEffect(() => {
        if (isParagraphInView) {
            paragraphControls.start("visible");
        }
    }, [isParagraphInView]);

    const imageFrames = [
        "/vapi1.png",
        "/vapi2.png",
        "/vapi3.png",
    ];

    const [index, setIndex] = useState(0);
    const platformRef = useRef(null);
    const width = 1050;

    const [active, setActive] = useState(null);
    const [zoomed, setZoomed] = useState(false);

    useEffect(() => {
        setZoomed(false);
        if (!active) return undefined;
        const onKey = (e) => e.key === "Escape" && setActive(null);
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        window.addEventListener("keydown", onKey);
        return () => {
            window.removeEventListener("keydown", onKey);
            document.body.style.overflow = prevOverflow;
        };
    }, [active]);

    const next = () => {
        if (index < imageFrames.length - 1) setIndex(index + 1);
    };

    const prev = () => {
        if (index > 0) setIndex(index - 1);
    };

    const goTo = (target) => {
        if (target === "end") setIndex(imageFrames.length - 1);
        else if (!isNaN(target)) setIndex(Number(target));
    };

    useEffect(() => {
        const handleKey = (e) => {
            if (e.key === "ArrowRight") next();
            if (e.key === "ArrowLeft") prev();
        };
        window.addEventListener("keydown", handleKey);
        return () => window.removeEventListener("keydown", handleKey);
    }, [index]);

    // useEffect(() => {
    //     if (platformRef.current) {
    //         platformRef.current.style.right = `${index * width}px`;
    //     }
    // }, [index]);




    return (
        <section className="text-black">
            <div className="mt-20 font-sans overflow-x-hidden relative ">
                <section className="relative z-10 py-16 md:py-24 px-6 md:px-12 lg:px-24">
                    <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center text-center lg:text-left">
                        <div className="space-y-8">
                            <motion.div
                                variants={fadeUp}
                                initial="hidden"
                                animate="show"
                                custom={0}
                            >
                                <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#06b5d428]  text-primary-dark font-medium">
                                    <span className="relative flex h-3 w-3 mr-2">
                                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#06B6D4] opacity-75"></span>
                                        <span className="relative inline-flex rounded-full h-3 w-3 bg-primary-dark"></span>
                                    </span>
                                   <span className="text-[#06B6D4]">Twilio IVRs</span>
                                </div>
                            </motion.div>
                           <motion.h1
                                className="text-4xl sd:4xl md:text-5xl lg:text-6xl font-display font-bold tracking-tight text-gray-900"
                                initial={{ y: 20 }}
                                animate={{ y: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut" }}
                            >
                                Advanced Twilio IVR Solutions{" "}
                                <span className="text-[#06B6D4]">for Your Business</span>
                            </motion.h1>
                          <motion.p
                                className="text-lg md:text-xl text-gray-600 max-w-2xl mt-2"
                                initial={{ y: 20 }}
                                animate={{ y: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.1 }}
                            >
                                We design and deploy custom Twilio IVR systems that handle call
                                routing, lead qualification, appointment scheduling, reminders,
                                and seamless transfers to live agents. Whether it's for sales,
                                support, or general inquiries -
                                <span className="ml-2 font-semibold">
                                    our IVRs help you streamline communication and deliver a
                                    better caller experience.
                                </span>
                            </motion.p>

                            <motion.div
                                variants={fadeUp}
                                initial="hidden"
                                animate="show"
                                custom={3}
                                className="flex flex-wrap gap-4 justify-center lg:justify-start"
                            >
                                <BrandButton as={Link} to="/contact" accent={ctaAccent}>
                                    Get a Free Consultation
                                </BrandButton>
                            </motion.div>

                            {/* <motion.div
                                variants={fadeUp}
                                initial="hidden"
                                animate="show"
                                custom={3}
                            >
                                <audio
                                    ref={audioRef}
                                    src="https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3"
                                    preload="metadata"
                                />
                                <div className="flex-1 flex flex-col sm:flex-row items-center  space-y-4 sm:space-y-0 sm:space-x-4">
                                    <div className="flex items-center">
                                        <div className="flex space-x-3">
                                            <button
                                                onClick={togglePlay}
                                                className="rounded-xl bg-[#06B6D4] w-10 h-10 flex items-center justify-center pl-0.5 text-white"
                                            >
                                                {isEnded ? (
                                                    <svg
                                                        className="w-5 h-5"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <polyline points="1 4 1 10 7 10" />
                                                        <path d="M3.51 15a9 9 0 1 0 .49-5.27L1 10" />
                                                    </svg>
                                                ) : isPlaying ? (
                                                    <svg
                                                        className="w-5 h-5"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <rect x="6" y="4" width="4" height="16" />
                                                        <rect x="14" y="4" width="4" height="16" />
                                                    </svg>
                                                ) : (
                                                    <svg
                                                        className="w-5 h-5"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <polygon points="5 3 19 12 5 21 5 3" />
                                                    </svg>
                                                )}
                                            </button>
                                        </div>
                                    </div>

                                    <div
                                        className="relative w-full min-w-0 cursor-pointer"
                                        onClick={handleSeek}
                                        ref={progressBarRef}
                                    >
                                        <div className="bg-[#06b5d428] h-2 w-full rounded-lg"></div>
                                        <div
                                            className="bg-[#06B6D4] h-2 rounded-lg absolute top-0 left-0 transition-all duration-200"
                                            style={{ width: `${progress}%` }}
                                        ></div>
                                    </div>
                                </div>
                            </motion.div>
                            <motion.p
                                className="text-sm md:text-md text-gray-600 max-w-2xl "
                                variants={fadeUp}
                                initial="hidden"
                                animate="show"
                                custom={4}
                            >
                                Hear how our Twilio IVR handles real calls - smart routing, faster responses, smoother experiences.
                            </motion.p> */}
                            {/* 
                            <motion.div
                                className="flex items-center pt-2 space-x-4"
                                variants={fadeUp}
                                initial="hidden"
                                animate="show"
                                custom={5}
                            >
                                <button class="px-8 py-4 rounded-xl bg-[#8B4AFA] w-full hover:bg-[#7238d6] transition-all text-white font-medium hover:bg-primary-darker shadow-lg shadow-primary-light/50 hover:shadow-primary-light/70 flex items-center justify-center">
                                    Talk With AI Agent Now
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-5 w-5 ml-2"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                </button>
                            </motion.div> */}
                        </div>

                        <div className="relative">
                            <motion.div
                                variants={fadeUp}
                                initial="hidden"
                                animate="show"
                                custom={0}
                                className="relative w-full max-w-md mx-auto rounded-3xl  shadow-2xl bg-[#06b5d428] border border-gray-100 p-6"
                            >
                                <div className="bg-white/80 backdrop-blur-sm border border-gray-100 rounded-2xl p-6 text-center relative">
                                    {/* Small Icon at Top-Right */}
                                    <motion.div
                                        variants={fadeUp}
                                        initial="hidden"
                                        animate="show"
                                        custom={4}
                                        className="absolute -top-20 p-8 text-5xl -right-20 text-[#06B6D4] rounded-2xl bg-[#06b5d428] backdrop-blur-sm   shadow-lg z-20 "
                                    >
                                        <CgTwilio />
                                    </motion.div>

                                    <motion.div
                                        variants={fadeUp}
                                        initial="hidden"
                                        animate="show"
                                        custom={6}
                                        className="absolute top-44 p-4 text-5xl -left-10 text-[#06B6D4] rounded-2xl bg-[#06b5d428] backdrop-blur-sm   shadow-lg z-20 "
                                    >
                                        <CgTwilio />
                                    </motion.div>
                                    <div className="text-sm font-medium text-gray-500 mb-2">
                                        On Call with
                                    </div>
                                    <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                                        Twilio IVR System
                                    </h2>

                                    {/* Waveform */}
                                    <div className="flex items-center justify-center space-x-1 mb-6 h-10">
                                        {[...Array(30)].map((_, i) => (
                                            <div
                                                key={i}
                                                className="w-1 bg-[#06B6D4] rounded animate-pulse-bar"
                                                style={{
                                                    height: `${Math.random() * 40 + 10}px`,
                                                    animationDuration: `${(1 + Math.random()).toFixed(
                                                        2
                                                    )}s`,
                                                }}
                                            />
                                        ))}
                                    </div>

                                    {/* IVR prompt */}
                                    <p className="text-gray-600 text-sm mb-6">
                                        Press 1 to schedule an appointment. Press 2 for clinic
                                        hours. Press 3 to talk to a representative.
                                    </p>

                                    {/* Call controls */}
                                    <div className="flex justify-center space-x-6">
                                        <button className="w-12 h-12 bg-red-500 text-white rounded-full shadow-lg flex items-center justify-center">
                                            {/* End icon */}
                                        </button>
                                        <button className="w-12 h-12 bg-gray-200 text-gray-800 rounded-full shadow-inner flex items-center justify-center">
                                            {/* Mute icon */}
                                        </button>
                                    </div>
                                </div>
                            </motion.div>
                        </div>
                    </div>
                </section>
            </div>
            {/* <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-20 pb-16 text-center lg:pt-32">
                <motion.p
                    className="mx-auto -mt-4 max-w-2xl text-md tracking-widest text-slate-700 sm:mt-6"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, ease: "easeOut" }}
                    viewport={{ once: true }}
                >
                    We Provide
                    <span className="border-b border-dotted border-slate-300 ml-2">
                        Both
                    </span>
                </motion.p>

                <motion.h1
                    className="mx-auto mt-4 max-w-4xl font-display text-5xl font-semibold tracking-tight text-slate-900 sm:text-7xl leading-tight"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, ease: "easeOut", delay: 0.3 }}
                    viewport={{ once: true }}
                >
                    <span className="inline-block"> Voice AI Integration Options</span>
                </motion.h1>

                <motion.p
                    className="mx-auto mt-9 max-w-2xl text-lg tracking-tight text-slate-600 sm:mt-6"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, ease: "easeOut", delay: 0.6 }}
                    viewport={{ once: true }}
                >
                    Compare the benefits, costs, and timelines of using pre-built voice
                    platforms versus building your own custom AI voice assistant tailored
                    to your business needs.
                </motion.p>
                <div className=" py-10 grid grid-cols-1 text-start md:grid-cols-2 gap-8">
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3, ease: "easeOut", delay: 0.9 }}
                        viewport={{ once: true }}
                        className="relative p-8  border border-gray-200 rounded-2xl shadow-2xl flex flex-col"
                    >
                        <h3 className="text-2xl font-semibold text-green-500 mb-3">
                            Pre-Built Solution
                        </h3>
                        <p className="text-gray-700 mb-4">
                            Leverage ready-made platforms like <strong>Vapi</strong>,{" "}
                            <strong>Retell AI</strong> for voice, and <strong>Twilio</strong>{" "}
                            for telephony.
                        </p>
                        <ul role="list" class="mt-1 space-y-6">
                            <li class="flex">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    class="flex-shrink-0 w-6 h-6 text-emerald-500"
                                    aria-hidden="true"
                                >
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                                <span class="ml-3 ">Fast Setup</span>
                            </li>
                            <li class="flex">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    class="flex-shrink-0 w-6 h-6 text-emerald-500"
                                    aria-hidden="true"
                                >
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                                <span class="ml-3 ">Lower Development Cost</span>
                            </li>
                            <li class="flex">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    class="flex-shrink-0 w-6 h-6 text-yellow-500"
                                    aria-hidden="true"
                                >
                                    <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"></path>
                                    <line x1="12" y1="9" x2="12" y2="13"></line>
                                    <line x1="12" y1="17" x2="12" y2="17"></line>
                                </svg>
                                <span class="ml-3 ">Higher Monthly Usage Fees</span>
                            </li>
                        </ul>
                        <div className="overflow-x-auto mt-6">
                            <table className="min-w-full text-sm text-left text-gray-800 bg-green-50 rounded-lg">
                                <thead className="text-xs uppercase text-green-700 bg-green-100">
                                    <tr>
                                        <th scope="col" className="px-4 py-3">
                                            Service
                                        </th>
                                        <th scope="col" className="px-4 py-3 text-end">
                                            Cost
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="border-t border-green-200">
                                        <td className="px-4 py-2 font-medium">Vapi</td>
                                        <td className="px-4 py-2 text-end">$0.14/min</td>
                                    </tr>
                                    <tr className="border-t border-green-200">
                                        <td className="px-4 py-2 font-medium">Twilio</td>
                                        <td className="px-4 py-2 text-end">$0.0085/min</td>
                                    </tr>
                                    <tr className="border-t border-green-200">
                                        <td className="px-4 py-2 font-medium">Total</td>
                                        <td className="px-4 py-2 text-end">~$0.1485/min</td>
                                    </tr>
                                    <tr className="border-t border-green-200">
                                        <td className="px-4 py-2 font-medium">Development Cost</td>
                                        <td className="px-4 py-2 text-end">Low</td>
                                    </tr>
                                    <tr className="border-t border-green-200">
                                        <td className="px-4 py-2 font-medium">
                                            Estimated Timeline
                                        </td>
                                        <td className="px-4 py-2 text-end">1–2 weeks</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3, ease: "easeOut", delay: 1.2 }}
                        viewport={{ once: true }}
                        className="relative p-8 border border-gray-200 rounded-2xl shadow-2xl flex flex-col"
                    >
                        <p className="absolute top-0 py-1.5 px-4 bg-[#8B4AFA] text-white rounded-full text-xs font-semibold uppercase tracking-wide transform -translate-y-1/2">
                            Popular
                        </p>
                        <h3 className="text-2xl font-semibold text-[#8B4AFA] mb-3">
                            Custom Solution
                        </h3>
                        <p className="text-gray-700 mb-4">
                            Build a fully tailored AI voice assistant using{" "}
                            <strong>OpenAI</strong> for voice intelligence and{" "}
                            <strong>Twilio</strong> for telephony.
                        </p>

                        <ul role="list" className="mt-1 space-y-6">
                            <li className="flex">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="flex-shrink-0 w-6 h-6 text-[#8B4AFA]"
                                    aria-hidden="true"
                                >
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                                <span className="ml-3">Extremely Low Ongoing Costs</span>
                            </li>

                            <li className="flex">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="flex-shrink-0 w-6 h-6 text-[#8B4AFA]"
                                    aria-hidden="true"
                                >
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                                <span className="ml-3">Full Customization</span>
                            </li>

                            <li className="flex">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="flex-shrink-0 w-6 h-6 text-yellow-500"
                                    aria-hidden="true"
                                >
                                    <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"></path>
                                    <line x1="12" y1="9" x2="12" y2="13"></line>
                                    <line x1="12" y1="17" x2="12" y2="17"></line>
                                </svg>
                                <span className="ml-3">Higher Upfront Development Cost</span>
                            </li>
                        </ul>

                        <div className="overflow-x-auto mt-6">
                            <table className="min-w-full text-sm text-left text-gray-800  bg-purple-50 rounded-lg">
                                <thead className="text-xs uppercase text-purple-700 bg-purple-100">
                                    <tr>
                                        <th scope="col" className="px-4 py-3">
                                            Service
                                        </th>
                                        <th scope="col" className="px-4 py-3 text-end">
                                            Cost
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="border-t border-purple-200">
                                        <td className="px-4 py-2 font-medium">OpenAI</td>
                                        <td className="px-4 py-2 text-end">~$0.01/min</td>
                                    </tr>
                                    <tr className="border-t border-purple-200">
                                        <td className="px-4 py-2 font-medium">Twilio</td>
                                        <td className="px-4 py-2 text-end">$0.0085/min</td>
                                    </tr>
                                    <tr className="border-t border-purple-200">
                                        <td className="px-4 py-2 font-medium">Total</td>
                                        <td className="px-4 py-2 text-end">~$0.0185/min</td>
                                    </tr>
                                    <tr className="border-t border-purple-200">
                                        <td className="px-4 py-2 font-medium">Development Cost</td>
                                        <td className="px-4 py-2 text-end">High (one-time)</td>
                                    </tr>
                                    <tr className="border-t border-purple-200">
                                        <td className="px-4 py-2 font-medium">
                                            Estimated Timeline
                                        </td>
                                        <td className="px-4 py-2 text-end">3–4 weeks</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </motion.div>
                </div>
            </div> */}
            {/* <IVRFlowChart /> */}
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-10 pb-16 text-center lg:pt-20">
                <motion.p
                    className="mx-auto -mt-4 max-w-2xl text-md tracking-widest text-slate-700 sm:mt-6"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, ease: "easeOut" }}
                    viewport={{ once: true }}
                >
                    Our
                    <span className="border-b border-dotted border-slate-300 ml-2">
                        Work
                    </span>
                </motion.p>

                <motion.h2
                    className="mx-auto mt-4 max-w-4xl font-display text-3xl sm:text-3xl md:text-5xl font-semibold tracking-tight text-slate-900  leading-tight"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, ease: "easeOut", delay: 0.3 }}
                    viewport={{ once: true }}
                >
                    <span className="inline-block">Some Of Our IVRs </span>
                </motion.h2>

                <motion.p
                    className="mx-auto mt-9 max-w-2xl text-lg tracking-tight text-slate-600 sm:mt-6"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, ease: "easeOut", delay: 0.6 }}
                    viewport={{ once: true }}
                >
                    Explore a showcase of powerful, production-ready IVR systems we've
                    created - each designed for optimal performance, intuitive user
                    interaction, and seamless voice flow
                </motion.p>

                <motion.div
                    className="mx-auto mt-8 max-w-3xl rounded-2xl bg-[#06b5d41a] p-6 text-left"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, ease: "easeOut" }}
                    viewport={{ once: true }}
                >
                    <p className="text-sm font-semibold text-[#0E7490]">How these flows work</p>
                    <ul className="mt-3 space-y-2 text-slate-700">
                        <li>1. The caller hears a greeting and a short menu.</li>
                        <li>2. Their keypad choice routes the call, books an appointment or gives the information they need.</li>
                        <li>3. Anything else goes to a live agent.</li>
                    </ul>
                </motion.div>

                {/* Carousel - only for md and up */}
                               <motion.div
                    className="gallery w-full rounded mx-auto m-8 hidden md:block"
                    style={{ maxWidth: `${width}px` }}
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, ease: "easeOut", delay: 0.9 }}
                    viewport={{ once: true }}
                >
                    <div className="content-area w-full overflow-hidden">
                        <div
                            className="platform flex transition-transform duration-300"
                            style={{
                                width: `${imageFrames.length * 100}%`,
                                transform: `translateX(-${(index * 100) / imageFrames.length}%)`,
                            }}
                        >
                            {imageFrames.map((src, i) => (
                                <div
                                    key={i}
                                    className="each-frame flex-none flex items-center justify-center"
                                    style={{ width: `${100 / imageFrames.length}%` }}
                                >
                                    <button
                                        type="button"
                                        onClick={() => setActive({ src, caption: `IVR flow ${i + 1}` })}
                                        aria-label={`Enlarge IVR flow ${i + 1}`}
                                        className="block w-full cursor-zoom-in"
                                    >
                                        <img
                                            src={src}
                                            width="1200"
                                            height="600"
                                            loading="lazy"
                                            decoding="async"
                                            className="w-full h-auto border-2 rounded-2xl object-contain"
                                            alt={`IVR flow ${i + 1}`}
                                        />
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Carousel buttons */}
                    <div className="top flex p-2 items-center justify-center">
                        <div className="buttons flex gap-3 text-gray-600 mr-1">
                            <motion.svg
                                whileHover={{ scale: 1.2 }}
                                whileTap={{ scale: 1.1 }}
                                onClick={prev}
                                className="w-10 rounded-lg bg-[#06B6D4] p-2 cursor-pointer"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="#fff"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                                />
                            </motion.svg>
                            <motion.svg
                                whileHover={{ scale: 1.2 }}
                                whileTap={{ scale: 1.1 }}
                                onClick={next}
                                className="w-10 rounded-lg bg-[#06B6D4] p-2 cursor-pointer"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="#fff"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                                />
                            </motion.svg>
                        </div>
                    </div>
                </motion.div>

                {/* Column layout for small screens */}
                <div className="flex flex-col md:hidden mt-8">
                    {imageFrames.map((src, i) => (
                        <div
                            key={i}
                            className="w-full flex items-center justify-center mb-4"
                        >
                             <button
                                type="button"
                                onClick={() => setActive({ src, caption: `IVR flow ${i + 1}` })}
                                className="block w-full"
                            >
                               <img
                                src={src}
                                width="1200"
                                height="600"
                                loading="lazy"
                                decoding="async"
                                className="w-full h-auto border-2 rounded-2xl object-contain"
                                alt={`IVR flow ${i + 1}`}
                            />
                            </button>
                        </div>
                    ))}
                               </div>
            </div>

            <CTABanner
                title="Need a Twilio IVR for your business?"
                text="Tell us how your calls should flow, and we'll design, build and deploy it for you."
                buttonLabel="Get a Free Consultation"
                color="#0E7490"
                hoverBg="#ecfeff"
            />

            {active && (
                <motion.div
                    className="fixed inset-0 z-[1000] overflow-auto bg-black/80 p-4"
                    onClick={() => setActive(null)}
                    role="dialog"
                    aria-modal="true"
                    aria-label={active.caption}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.2 }}
                >
                    <button
                        type="button"
                        onClick={() => setActive(null)}
                        aria-label="Close"
                        className="fixed right-5 top-5 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-white text-slate-900 shadow-lg"
                    >
                        <FaTimes />
                    </button>
                    <div className="flex min-h-full">
                        <img
                            src={active.src}
                            alt={active.caption}
                            onClick={(e) => {
                                e.stopPropagation();
                                setZoomed((z) => !z);
                            }}
                            className={`m-auto rounded-lg bg-white shadow-2xl ${
                                zoomed
                                    ? "max-w-none w-[1800px] cursor-zoom-out"
                                    : "max-h-[90vh] max-w-full object-contain cursor-zoom-in"
                            }`}
                        />
                    </div>
                </motion.div>
            )}
        </section>
    )
}
